/* Copyright (C) 2019 SmartboxTv S.A. - All rights reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Erasmo Marín <emarin@smartboxtv.com>
 */

import get from 'lodash/get';
import has from 'lodash/has';
import isString from 'lodash/isString';
import mapKeys from 'lodash/mapKeys';
import isObject from 'lodash/isObject';
import isArray from 'lodash/isArray';
import forEach from 'lodash/forEach';
import cloneDeep from 'lodash/cloneDeep';
import defaultTheme from './default.json';
import blueTheme from './blue.json';
import lightTheme from './light.json';

/*Based on cinematic-react theme parser*/
class ThemeParser {
    constructor() {
        this.variables = {};
        this._theme = {};
    }

    getTheme = (name = 'default') => {
        switch (name) {
            case 'blue':
                this.parse(blueTheme);
                break;
            case 'light':
                this.parse(lightTheme);
                break;
            default:
                this.parse(defaultTheme);
        }
        return this._theme;
    };

    /**
     * Main function that parses an ambiance object, detect variables and replace all the found ocurrences
     * @param  {Object} str [Object or stringified cinematic ambiance object]
     * @return {[Object]}   [The parsed ciematic ambiance object]
     */
    parse = (str = {}) => {
        if (isString(str)) {
            try {
                this._theme = JSON.parse(str);
            } catch (e) {
                this._theme = {};
                console.warning('Theme manager: Error parsing theme', e);
            }
        } else {
            this._theme = cloneDeep(str);
        }

        this._parseVariables(this._theme);
        this._replaceVariables(this._theme);
        return this._theme;
    };

    /**
     * Get all the variable declaration and their values in the cinematic ambiance object saving them in this.variables
     * @param  {Object} node    [Parent tree node or the ambiance object]
     * @param  {[type]} nodeKey [The node key or null if it's the ambiance object]
     */
    _parseVariables = (node = {}, nodeKey) => {
        mapKeys(node, (node, key) => {
            if (isObject(node) || isArray(node)) {
                this._parseVariables(node, key);
            } else if (key.substring(0, 1) === '@') {
                this.variables[key.slice(1)] = node;
            }
        });
    };

    /**
     * Replace all the variable references found in the ambiance object and in this.variables
     * @param  {Object} node [Parent tree node or the ambiance object]
     */
    _replaceVariables = (node = {}) => {
        forEach(node, (val, key) => {
            if (isString(val) && val.substring(0, 1) === '@' && has(this.variables, val.slice(1))) {
                node[key] = get(this.variables, val.slice(1));
            } else if (isObject(val) || isArray(val)) {
                this._replaceVariables(val);
            }
        });
    };
}

const themes = new ThemeParser();
themes.parse(defaultTheme);

export default themes;
